import {gql} from "@apollo/client";
import {createEstablishmentMutation, getAllEstablishmentsQuery} from "./establishmentGql";
import filterDataGql, {executeQueryUtil} from "../utils/gqlUtil";
import apolloClient from "../apolloClient/ApolloClient";


const common = `
    id
    chartImplementationId
    dataGridImplementationId
    boardId
    xGrid
    yGrid
    wGrid
    hGrid
`

export const getChartBoardsItemsQuery = (userId) => {

  return gql`
    query {
      getChartChartBoardItems(userId: "${userId}") {
        ${common}
      }
    }
  `;
}

export const getChartBoardItemQuery = (userId, chartBoardItemId) => {

    return gql`
    query {
      getChartBoardItem(userId: "${userId}", chartBoardItemId: "${chartBoardItemId}") {
        ${common}
      }
    }
  `;
}

export const createChartBoardItemMutation = (userId, data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        [] );
    return gql`mutation {
      addChartBoardItem(userId: "${userId}", data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const updateChartBoardItemMutation = (userId, data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        ["groupBy"] );
    return gql`mutation {
      updateChartBoardItem(userId: "${userId}", data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const bulkDeleteChartBoardItemMutation = (userId, ids) => {
    var idsString =  JSON.stringify(ids);

    return gql`
    mutation {
      bulkDeleteChartBoardItem(userId: "${userId}", chartBoardItemIds: ${idsString}) {
        ids
      }
    }
  `;
}

export const addDataChartBoardItemToCache = async (userId, datas) => {
    if (!datas) {
        return
    }
    const query = getChartBoardsItemsQuery(userId);
    const data = await executeQueryUtil(query);

    if (data) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getChartChartBoardItems: [...data.data.getChartChartBoardItems, ...datas]
            },
        });
    }
}

export const deletehartBoardItemFromCache = async (userId, ids) => {
    const query = getChartBoardsItemsQuery(userId);
    const res = await executeQueryUtil(query);
    const newData = res.data.getChartChartBoardItems.filter(item =>
        !ids.includes(item.id)
    )

    if (res) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getChartChartBoardItems: [...newData]
            },
        });
    }
}






